module.exports = __webpack_public_path__ + "static/media/Cheese_Naan.a583f156.jpeg";